import { Events, NotificationResponseEvent } from './events';
import { Context } from './types';

export const setNotificationsAction = ({
  context,
  event,
}: {
  context: Context;
  event: Events;
}): Partial<Context> => {
  const { output } = event as NotificationResponseEvent;
  // Keep optimistically-dismissed notifications hidden even if the fetch
  // raced ahead of their PATCH.
  return {
    notifications: output.filter((n) => !context.pendingReadIds.includes(n.id)),
  };
};
